import { render, staticRenderFns } from "./platmap.vue?vue&type=template&id=51b0fb87&scoped=true&"
import script from "./platmap.vue?vue&type=script&lang=js&"
export * from "./platmap.vue?vue&type=script&lang=js&"
import style0 from "./platmap.vue?vue&type=style&index=0&lang=css&"
import style1 from "./platmap.vue?vue&type=style&index=1&id=51b0fb87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0fb87",
  null
  
)

export default component.exports